document.addEventListener('DOMContentLoaded', setup, false)

function setup () {
	console.log('cm-license-assistant::setup')
}

window.addEventListener("message", (event) => {
  if (event.origin !== METACOM_LICENSE_HOST) {
    return;
	}
	if (event.data.event === 'adjust_height') {
		jQuery('#license-assistant').height(event.data.data.height)
		return
	}
	if (event.data.event === 'scroll_to_top') {
		const assistantTop = jQuery('#license-assistant').offset().top
		const html = jQuery('html')
		if (html.scrollTop() > assistantTop) {
			html.scrollTop(assistantTop)
		}
		return
	}
	if (event.data.event !== 'add_to_cart') {
		console.log('Unknown event: ', event)
		return
	}
	const eventPayload = event.data.data
	const data = {
		action: 'm9_license_assistant',
		products: eventPayload.products,
		sessionId: eventPayload.sessionId,
		sessionToken: eventPayload.sessionToken,
		offerToken: eventPayload.offerToken,
		billing: eventPayload.billing,
		purchaseType: eventPayload.purchaseType
	}
	jQuery.post(
		window.CM_LICENSE_ASSISTANT_ADMIN_POST_URL,
		data,
		function( response ) {
			window.location.href = '/warenkorb/';
		}
	);

}, false)